module.exports = __webpack_public_path__ + "static/Ruchi_Khajanchi_new.736f076b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Ruchi_Khajanchi_new.jpg
// module id = 924
// module chunks = 146520050992020